import 'core-js/stable';
// Import it with the name you want to use below
import Autosuggest from '@/components/Autosuggest'; 

document.addEventListener('DOMContentLoaded', function () {
    // This matches the name in your import statement
    Autosuggest.init({ 
        selector: 'input[data-cuautosuggest="true"]' 
    });
});
